import type { ComponentProps } from "react";

import { ColorPicker as ColorPalettePicker } from "react-color-palette";
import "react-color-palette/css";

type ColorPalettePickerProps = ComponentProps<typeof ColorPalettePicker>;

interface ColorPickerProps extends ColorPalettePickerProps {}

const ColorPicker = ({
	hideInput = ["hsv", "rgb"],
	hideAlpha = true,
	...restProps
}: ColorPickerProps) => {
	return (
		<ColorPalettePicker
			hideInput={hideInput}
			hideAlpha={hideAlpha}
			{...restProps}
		/>
	);
};

export default ColorPicker;
